import DependencyList from './DependencyList.container';

export default DependencyList;
